import React from "react";
import { useApp } from "@/context/AppContext";
import useSEO from "@/hooks/useSEO";
import { PageHero } from "@/components/primitives";
import { Reveal } from "@/components/Reveal";

const Block = ({ title, children, testId }) => (
  <Reveal>
    <div data-testid={testId}>
      <h2 className="font-montserrat text-xl font-bold text-neutral-900 sm:text-2xl">{title}</h2>
      <div className="mt-3 space-y-1.5 font-poppins text-base leading-relaxed text-neutral-600">{children}</div>
    </div>
  </Reveal>
);

const Field = ({ label, value }) => (
  <p><span className="font-semibold text-neutral-800">{label} :</span> {value}</p>
);

export default function MentionsLegales() {
  const { t } = useApp();
  useSEO(
    { fr: "Mentions légales | Agrivoire Export SARL", en: "Legal notice | Agrivoire Export SARL" },
    { fr: "Mentions légales d'Agrivoire Export SARL.", en: "Legal notice of Agrivoire Export SARL." }
  );

  return (
    <div data-testid="legal-page">
      <PageHero kicker={t("legal", "hero_kicker")} title={t("legal", "title")} />
      <section className="mx-auto max-w-3xl px-5 py-20 md:px-10 md:py-28">
        <div className="space-y-12">
          <Block title={t("legal", "editor_title")} testId="legal-editor">
            <p>{t("legal", "editor_intro")}</p>
            <p className="font-semibold text-neutral-800">{t("legal", "editor_company")}</p>
            <p>{t("legal", "editor_capital")}</p>
            <Field label={t("legal", "editor_office_label")} value={t("legal", "editor_office")} />
            <p>{t("legal", "editor_country")}</p>
          </Block>

          <Block title={t("legal", "director_title")} testId="legal-director">
            <p>{t("legal", "director_body")}</p>
          </Block>

          <Block title={t("legal", "contact_title")} testId="legal-contact">
            <p>
              <span className="font-semibold text-neutral-800">{t("legal", "contact_email_label")} :</span>{" "}
              <a href={`mailto:${t("legal", "contact_email")}`} className="text-[#1CADE4] hover:underline">
                {t("legal", "contact_email")}
              </a>
            </p>
            <Field label={t("legal", "contact_phone_label")} value={t("legal", "contact_phone")} />
          </Block>

          <Block title={t("legal", "hosting_title")} testId="legal-hosting">
            <p>{t("legal", "hosting_body")}</p>
          </Block>

          <Block title={t("legal", "ip_title")} testId="legal-ip">
            <p>{t("legal", "ip_body")}</p>
          </Block>

          <Block title={t("legal", "data_title")} testId="legal-data">
            <p>{t("legal", "data_body")}</p>
          </Block>
        </div>
      </section>
    </div>
  );
}
